import { TransformationRuleDefinitionDTO } from "../DTO/transformationRuleDefinitionDTO";

export class TransformationRuleDefinition{
    public id!: number;
    public name!: string; //should be unique accross rule set
    public description!: string;
    public ruleType!: string; //d=default value rule, c=conditional rule, t=transformational rule, r=record rule, f=formula
    public outputFileType!: string; //csv or fl or mrt-csv or mrt-fl or *=all: some rules don't make sense in certain output file formats, like 'padding' only makes sense in fl output. can be a mix seperated by comma
    public inputDataType!: string; //STRING, NUMERIC, DATE, *=all if NULL then it applies only for output with no input (creation of additional output fields without input)
    public outputDataType!: string; //STRING, NUMERIC, DATE
    public inputDataCount!: number; //minimum value=1. 
    public parameterCount!: number; //currently only 0,1,2 supported
    public parameterLabels!: string; //comma separated string for Parameter labels and their type [options], maxLength: parameter1:2,parameter2:3,parameter3,... ;if maxLength not defined then we default to 1024  

    private parameterLabelsArray!:{label:string, type:string, maxLength:number, options:string[]}[];

    public static mapFromDTO(param:TransformationRuleDefinitionDTO):TransformationRuleDefinition{ 
        if (!param) throw new Error("parameter is null")
        let obj = new TransformationRuleDefinition();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.description = param.description;
            obj.ruleType = param.ruleType;
            obj.outputFileType = param.outputFileType;
            obj.inputDataType = param.inputDataType;
            obj.outputDataType = param.outputDataType;
            obj.inputDataCount = param.inputDataCount;
            obj.parameterCount = param.parameterCount;
            obj.parameterLabels = param.parameterLabels;
            obj.createParameterLabelsArray();
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:TransformationRuleDefinition):TransformationRuleDefinitionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new TransformationRuleDefinitionDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.description = param.description;
            dto.ruleType = param.ruleType;
            dto.outputFileType = param.outputFileType;
            dto.inputDataType = param.inputDataType;
            dto.outputDataType = param.outputDataType;
            dto.inputDataCount = param.inputDataCount;
            dto.parameterCount = param.parameterCount;
            dto.parameterLabels = param.parameterLabels;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    private createParameterLabelsArray(){
        this.parameterLabelsArray=[];
        if(this.parameterLabels){
            let labelItemArray = this.parameterLabels.split(',');
            labelItemArray.forEach(labelItem => {
                let labelItemComponent=labelItem.split(':');
                let label:string=labelItemComponent[0];
                let type:string='string';
                let options:string[]=[];
                let maxLength:number=1024; //our default maxLength for Parameters is 1024
                if(labelItemComponent.length>1){
                    if(labelItemComponent[1]=='n'){
                        type='numeric';
                    }
                    else if(labelItemComponent[1]=='mlt'){
                        type='mlt';
                    }
                    else if(labelItemComponent[1].startsWith('opt[')){
                        type='opt';
                        if(labelItemComponent[1].startsWith('opt[')) options=labelItemComponent[1].substring(4,labelItemComponent[1].length-1).split('|');
                    }
                    else if(labelItemComponent[1].startsWith('opt{SelectedInputFields}')){
                        type='opt-inputfields';
                    }
                    else if(!isNaN(Number(labelItemComponent[1]))){
                        maxLength=Number(labelItemComponent[1]);
                    }
                }
                this.parameterLabelsArray.push({label:label, type:type, maxLength:maxLength, options:options});
            });
        }
    }

    public getParameterLabel(index:number):{label:string, type:string, maxLength:number, options:string[]}{
        return this.parameterLabelsArray[index];
    }

    public canUseForFileType(fileType:string){
        return this.outputFileType=="*" || this.outputFileType.split(',').indexOf(fileType)>-1;
    }
}